import React from 'react'
import reactDom from 'react-dom'
import './loader.css'

export default function CircularLoader() {
    return reactDom.createPortal(
        <div className="modal">
			<div className="loader"></div>
		</div>
    ,document.body)
}
